export var AccountReactivationIA = function AccountReactivationIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return ACCOUNT_REACTIVATION_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize)];
    }
  };
};
var ACCOUNT_REACTIVATION_TITLE = function ACCOUNT_REACTIVATION_TITLE(strictLocalize) {
  return strictLocalize({
    id: "pEaCXm",
    defaultMessage: [{
      "type": 0,
      "value": "Account opnieuw activeren"
    }]
  });
};
var ACCOUNT_REACTIVATION_DESCRIPTION = function ACCOUNT_REACTIVATION_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "xhsL1w",
    defaultMessage: [{
      "type": 0,
      "value": "Als je je account eerder hebt gedeactiveerd, kun je via de onderstaande optie contact met ons opnemen om een verzoek tot heractivering in te dienen. Opmerking: alle verzoeken over accountverificatie moeten gedaan worden via Mijn account > Onboarding > Accountverificatie"
    }]
  });
};